// DataWrapper
import {Node} from 'tiptap'

export default class Chart extends Node {
  get name() {
    return 'iframe'
  }

  get schema() {
    return {
      group: 'block',
      draggable: true,
      selectable: false,
      inline: false,
      attrs: {
        tag: {
          default: 'iframe',
        },
        src: {
          default: null,
        },
        tabindex: {
          default: -1,
        },
        class: {
          default: null,
        },
        style: {
          default: null,
        },
        height: {
          default: null,
        },
        width: {
          default: null,
        },
        alt: {
          default: null,
        },
        img: {
          default: null,
        },
      },
      parseDOM: [
        {
          tag: 'div.iframe-parent',
          getAttrs: (element) => {
            const frame = element.querySelector('iframe')
            const img = element.querySelector('img')
            return frame
              ? {
                  src: frame.getAttribute('src'),
                  tabindex: frame.getAttribute('tabindex'),
                  style: frame.getAttribute('style'),
                  height: frame.getAttribute('height'),
                  width: frame.getAttribute('width'),
                  img: img.getAttribute('src'),
                  alt: img.getAttribute('alt'),
                }
              : {}
          },
        },
      ],
      toDOM: ({attrs}) => {
        return [
          'div',
          {class: 'iframe-parent'},
          [
            'iframe',
            {
              src: attrs.src,
              height: attrs.height,
              width: attrs.width,
              loading: 'lazy',
            },
          ],
          ['img', {class: 'dw-alt', src: attrs.img, alt: attrs.alt, loading: 'lazy'}],
        ]
      },
    }
  }

  commands({type}) {
    return (attrs) => (state, dispatch) => {
      const {selection} = state
      const position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }

  get view() {
    return {
      props: ['node', 'updateAttrs', 'view'],
      computed: {
        src: {
          get() {
            return this.node.attrs.src
          },
          set(src) {
            this.updateAttrs({
              src,
            })
          },
        },
        height: {
          get() {
            return this.node.attrs.height
          },
        },
        alt: {
          get() {
            return this.node.attrs.alt
          },
        },
        img: {
          get() {
            return this.node.attrs.img
          },
        },
        width: {
          get() {
            return this.node.attrs.width
          },
        },
        style: {
          get() {
            return this.node.attrs.style
          },
        },
      },
      template: `
        <div class="iframe" tabindex="-1" :style="style">
          <iframe class="iframe__embed" :src="src" :style="style" frameborder="0" :height="height" :width="width"></iframe>
          <img class="dw-alt" :src="img" :alt="alt" />
        </div>
      `,
    }
  }
}
